module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/twitter-icon-2ded71d100c66614ae7da0932aafc8ed.png";